import React from 'react';
import { ThemeProvider } from 'styled-components';

import theme from '../../../../assets/stylesheets/_settings.global.scss';
import { Container, ContentContainer } from '../shared/styles';
import { propTypes } from './prop-types';
import Form from './form-components/form';

export default function NewAnnouncement(props) {
  return (
    <ThemeProvider theme={theme}>
      <Container>
        <ContentContainer>
          <h1>Creating Feature Announcement</h1>
          <Form {...props} />
        </ContentContainer>
      </Container>
    </ThemeProvider>
  );
}

NewAnnouncement.propTypes = propTypes;
